import CoreUtils from '../../../utils/coreUtils.js';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';

export default class NodeConvexHull extends Node
{
	static physicsPlugin = null;
	static existingPhysicsEngine = null;

	constructor(pParent)
	{
		super(pParent);

		if(!NodeConvexHull.physicsPlugin)
			NodeConvexHull.physicsPlugin = new BABYLON.HavokPlugin();
		
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addInput(PARAM_TYPE.FLOAT, 'quality', 100, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'convexHull';
	}

	createMeshFromPhysicsBody(body, scene)
	{
		const bodyInfoGeom = NodeConvexHull.physicsPlugin.getBodyGeometry(body);
		const { positions, indices } = bodyInfoGeom;

		const resMesh = new BABYLON.Mesh("custom", scene);
		indices.reverse();
    
		const vertexData = new BABYLON.VertexData();
		vertexData.positions = positions;
		vertexData.indices = indices;

		vertexData.applyToMesh(resMesh);
		return resMesh;
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList || pGeoList.length === 0)
			return [];

		// We do this because disablePhysicsEngine() actually disposes, not disables,
		// the engine, which for us would be highly inefficient. So we initialize it once,
		// then "save" it and reuse.
		if(NodeConvexHull.existingPhysicsEngine)
			scene._physicsEngine = NodeConvexHull.existingPhysicsEngine;
		else
		{
			scene.enablePhysics(new BABYLON.Vector3(0, 110, 0), NodeConvexHull.physicsPlugin);
			NodeConvexHull.existingPhysicsEngine = scene._physicsEngine;
		}

		const scalingFactor = CoreUtils.interpolate(inputValues['quality']/100, 1, 250);

		let res = [];
		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			const origScaling = pSrcMesh.scaling.clone();
			pSrcMesh.scaling.scaleInPlace(scalingFactor, scalingFactor, scalingFactor);
			let aggregate = new BABYLON.PhysicsAggregate(pSrcMesh, BABYLON.PhysicsShapeType.CONVEX_HULL, {radius: 0.01, mass: 0, restitution: 0.95 }, scene);
			let resMesh = this.createMeshFromPhysicsBody(aggregate.body, scene);
			resMesh.scaling.scaleInPlace(1.0/scalingFactor, 1.0/scalingFactor, 1.0/scalingFactor);
			resMesh.convertToFlatShadedMesh();
			this.onMeshCreated(resMesh);
			aggregate.dispose();

			pSrcMesh.scaling = origScaling;

			res.push(resMesh);
		}

		scene._physicsEngine = null;
		return res;
	}
}
